module.exports = __webpack_public_path__ + "static/img/dentaltalk_lg_portrait.8d1aa75.png";


//////////////////
// WEBPACK FOOTER
// ./src/art/dentaltalk_lg_portrait.png
// module id = IxV/
// module chunks = 1